import { createBreakpoint } from "styled-components-breakpoint";

import { theme } from "../../styles/theme";

const { breakpoints } = theme;

export const breakpoint = createBreakpoint(breakpoints);
